const message = {
  unauthorizeMessage: 'Your session has expired, please log in again'
}
export default message;